module.exports = __webpack_public_path__ + "img/002.6bb5e571.jpg";